var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/star"
  }, /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.86495 1.75501L7.74495 3.51501C7.86495 3.76001 8.18495 3.99501 8.45495 4.04001L10.05 4.30501C11.07 4.47501 11.31 5.21501 10.575 5.94501L9.33495 7.18501C9.12495 7.39501 9.00995 7.80001 9.07495 8.09001L9.42995 9.62501C9.70995 10.84 9.06495 11.31 7.98995 10.675L6.49495 9.79001C6.22495 9.63001 5.77995 9.63001 5.50495 9.79001L4.00995 10.675C2.93995 11.31 2.28995 10.835 2.56995 9.62501L2.92495 8.09001C2.98995 7.80001 2.87495 7.39501 2.66495 7.18501L1.42495 5.94501C0.694954 5.21501 0.929955 4.47501 1.94995 4.30501L3.54495 4.04001C3.80995 3.99501 4.12995 3.76001 4.24995 3.51501L5.12995 1.75501C5.60995 0.800007 6.38995 0.800007 6.86495 1.75501Z",
    stroke: "#1D2023",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.99d3fbbbf519603eec5e323d674ad17b.svg";
export { ForwardRef as ReactComponent };